import request from "../request";

export const changePayAcquiring = ({orderId, acquiringId}) => {
	return request({
		url: `/pay/${orderId}/${acquiringId}`,
		type: "GET",
	});
};
